import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Creative%20animation%20studio%20with%20warm%20atmospheric%20lighting%20storyboard%20panels%20on%20wall%20drawing%20tablet%20on%20desk%20inspirational%20artistic%20workspace%20soft%20cream%20and%20warm%20amber%20gradient%20tones%20modern%20creative%20environment%20motivational%20atmosphere%20clean%20composition&width=1600&height=800&seq=cta-bg-01&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/60"></div>
      <div className="relative max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl text-background-50 mb-4">
          准备好开始你的同人动画之旅了吗？
        </h2>
        <p className="text-background-200 text-sm md:text-lg mb-8 max-w-2xl mx-auto leading-relaxed">
          无论你是零基础的动画新人，还是想提升技能的同人创作者，这里都有你需要的知识和资源。加入我们，一起创作！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/tutorials"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-background-50 font-medium hover:bg-accent-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-rocket-line text-lg"></i>
            立即开始学习
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50/20 text-background-50 font-medium hover:bg-background-50/30 backdrop-blur-sm transition-colors whitespace-nowrap"
          >
            <i className="ri-heart-line text-lg"></i>
            关于我们
          </Link>
        </div>
      </div>
    </section>
  );
}